<template>
	<div
		class="modal overlay"
		:class="isShow == true ? 'active' : ''"
		@click.self="modalClose"
	>
		<div class="modal_window">
			<div class="modal_window_head">
				<!-- 見出し -->
				<div class="modal_window_head_title">
					<i
						class="fas fa-fw fa-solid fa-arrow-right-to-bracket text-color-white2 mr-2"
					/>
					ログアウトしますか？
					<button type="button" class="circleBtn" @click="modalClose">
						<i class="fa-solid fa-xmark fa-fw" />
					</button>
				</div>
			</div>

			<div class="modal_window_content">
				<p class="font-normal">システムの利用を終了します。</p>
				<p class="mt-2 font-normal">
					ログアウトする場合は「ログアウト」ボタンをクリックしてください。
				</p>

				<div class="mt-20 flex justify-center">
					<Button
						:button-type="'button'"
						:button-class="''"
						:button-icon="'fa-arrow-right-to-bracket'"
						:button-text="'ログアウト'"
						@click="logOut"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup>
// その他
import Button from "@/components/atoms/Button.vue";
import { ref, computed } from "vue";
// utils
import scrollControlFunction from "@/utils/ScrollControl.js";

/* ---------------------------------------------------------------------------
utils
---------------------------------------------------------------------------- */
const { parentScrollUnlock } = scrollControlFunction();
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	isModal: Boolean
});
/* ---------------------------------------------------------------------------
	emits
---------------------------------------------------------------------------- */
const emit = defineEmits(["modalClose", "logOut"]);
/* ---------------------------------------------------------------------------
	computed
---------------------------------------------------------------------------- */
const isShow = computed({
	get: () => props.isModal,
	set: value => emit("modalClose", value)
});

/* ---------------------------------------------------------------------------
	ログアウト処理
---------------------------------------------------------------------------- */
async function logOut() {
	// 親のコンポーネントで検索を実行する
	emit("logOut");
	modalClose();
}
/* ---------------------------------------------------------------------------
	モーダル
---------------------------------------------------------------------------- */
// モーダルを閉じる
function modalClose() {
	isShow.value = false;
	// 親要素のscroll非表示解除
	parentScrollUnlock();
}
</script>
